export default {
  LOOP_REQUEST: 'LOOP/LOOP_REQUEST',
  LOOP_SUCCESS: 'LOOP/LOOP_SUCCESS',
  LOOP_FAIL: 'LOOP/LOOP_FAIL',

  UPDATE_LOOP: 'UPDATE_LOOP/STATUS_LOOP',
};
